import { useUpsertPersonRoleMutation } from "@/features/people/graphql/generated";
import { useToast } from "@/shared/contexts/toast.context";

export const usePersonRoleChange = () => {
  const { showToast } = useToast();
  const [updatePersonRole, { loading }] = useUpsertPersonRoleMutation();

  const handleUpdatePersonRole = async ({
    personId,
    role,
    objectType,
    objectId,
  }: {
    personId: number;
    role: string;
    objectType: string;
    objectId: number;
  }) => {
    try {
      const { data } = await updatePersonRole({
        variables: {
          personId,
          type: objectType,
          role,
          objectId,
        },
        onError: (error) => {
          showToast({
            message: "Error!",
            description: error.message,
            type: "error",
          });
        },
        refetchQueries: ["People"],
      });

      if (data?.upsertPersonRole?.success) {
        showToast({
          message: "Success!",
          description:
            data?.upsertPersonRole?.message || " Role updated successfully",
          type: "success",
        });
        return true;
      } else {
        showToast({
          message: "Oops!",
          description: data?.upsertPersonRole?.message || " Role update failed",
          type: "error",
        });
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  return { handleUpdatePersonRole, loading: false };
};
